import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Tracks whether the active form page should be showing its inline validation
 * messages.
 *
 * Forms that keep Submit enabled while invalid (see
 * BaseFormPage.allowSubmitWhenInvalid) call reveal() when the user taps Submit
 * on an invalid form; RvFieldErrorDirective then renders a red message under
 * every invalid control. Until that happens the directive stays inert, so
 * forms that gate Submit on validity behave exactly as before.
 *
 * Only one form page is on screen at a time, so a single app-wide flag is
 * enough — BaseFormPage.ngOnInit reset()s it so a previous page's reveal never
 * leaks into the next one.
 */
@Injectable({
  providedIn: 'root'
})
export class FormValidationService {
  private show_errors = new BehaviorSubject<boolean>(false)

  readonly show_errors$ = this.show_errors.asObservable()

  get showing(): boolean {
    return this.show_errors.value
  }

  reveal() {
    this.show_errors.next(true)
  }

  reset() {
    this.show_errors.next(false)
  }
}
